import { render, staticRenderFns } from "./JoinView.vue?vue&type=template&id=201f0e7c"
import script from "./JoinView.vue?vue&type=script&lang=js"
export * from "./JoinView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports